<template lang="pug">
span.help-block
  div(
    v-for="(error, index) in errors"
    :key="index"
  )
    | {{ error }}
  template(v-if="!errors[0]")
    div(
      v-for="(error, index) in formErrors"
      :key="index"
    )
      | {{ error }}

</template>

<script>
export default {
  name: 'AppDialogError',
  props: {
    errors: {
      type: Array,
      // Consumers pass `form.errors.<field>` which is `undefined` until a server error exists;
      // default to `[]` so the template's `errors[0]` check never throws on undefined.
      default: () => [],
    },
    formErrors: {
      type: Array,
      required: false
    },
  },
};
</script>
